// Keep 1× at the visual centre while preserving fine control at both ends.
// The backend accepts any factor in [0.1, 5], not just the labelled stops.
const stops = [
  { factor: 0.1, position: 0 },
  { factor: 0.25, position: 10 },
  { factor: 0.5, position: 25 },
  { factor: 1, position: 50 },
  { factor: 2, position: 75 },
  { factor: 4, position: 90 },
  { factor: 5, position: 100 },
];

const interpolate = (value, fromKey, toKey) => {
  const bounded = Math.max(stops[0][fromKey], Math.min(stops[stops.length - 1][fromKey], value));
  const upper = stops.findIndex((stop) => stop[fromKey] >= bounded);
  if (upper <= 0) return stops[0][toKey];
  const lower = stops[upper - 1];
  const next = stops[upper];
  return lower[toKey] + ((bounded - lower[fromKey]) / (next[fromKey] - lower[fromKey]))
    * (next[toKey] - lower[toKey]);
};

export const rankingFactorToPosition = factor => interpolate(Number(factor), 'factor', 'position');
export const rankingPositionToFactor = position => (
  Math.round(interpolate(Number(position), 'position', 'factor') * 100) / 100
);

export const rankingFactorMarks = stops.slice(1, -1).map(({ factor, position }) => ({
  value: position,
  factor,
}));
